import { style, styleVariants } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const noteBase = style({
  display: "flex",
  alignItems: "center",
  borderRadius: primitiveTokens.sizing["2x"]
});

export const noteSizes = styleVariants({
  default: {
    gap: primitiveTokens.sizing["4x"],
    padding: primitiveTokens.sizing["4x"]
  },
  compact: {
    gap: primitiveTokens.sizing["2x"],
    padding: `${primitiveTokens.sizing["1x"]} ${primitiveTokens.sizing["3x"]}`
  }
});

export const noteVariants = styleVariants({
  info: {
    backgroundColor: semanticThemeTokens.note.info.backgroundColor,
    color: semanticThemeTokens.note.info.textColor
  },
  warning: {
    backgroundColor: semanticThemeTokens.note.warning.backgroundColor,
    color: semanticThemeTokens.note.warning.textColor
  },
  error: {
    backgroundColor: semanticThemeTokens.note.error.backgroundColor,
    color: semanticThemeTokens.note.error.textColor
  }
});

export const noteIcon = style({
  flexShrink: 0,
  color: "inherit",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
});

export const noteIconSizes = styleVariants({
  default: {
    width: primitiveTokens.sizing["8x"],
    height: primitiveTokens.sizing["8x"],
    fontSize: primitiveTokens.sizing["8x"]
  },
  compact: {
    width: primitiveTokens.sizing["4x"],
    height: primitiveTokens.sizing["4x"],
    fontSize: primitiveTokens.sizing["4x"]
  }
});

export const noteText = style({
  color: "inherit",
  lineHeight: "1.5"
});

export const noteTextSizes = styleVariants({
  default: {
    fontSize: primitiveTokens.type.sm
  },
  compact: {
    fontSize: primitiveTokens.type.xs
  }
});
